import { useEffect } from 'react';
import './Modal.css';

/**
 * Shared modal with scoped class names (app-modal-*) to avoid the global CSS
 * collisions that previously happened when several pages each defined their own
 * `.modal` / `.modal-content` rules.
 */
export default function Modal({ title, onClose, children, footer }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div className="app-modal-overlay" onMouseDown={onClose}>
            <div className="app-modal-card" onMouseDown={(e) => e.stopPropagation()}>
                <div className="app-modal-header">
                    <h2 className="app-modal-title">{title}</h2>
                    <button type="button" className="app-modal-close" onClick={onClose} aria-label="Close">
                        &times;
                    </button>
                </div>
                <div className="app-modal-body">
                    {children}
                </div>
                {footer && <div className="app-modal-footer">{footer}</div>}
            </div>
        </div>
    );
}
